
import { Component, Vue } from "vue-property-decorator";
import SendTransitTicketForm from "@/components/forms/SendTransitTicketForm.vue";
import FormCard from "@/components/FormCard.vue";

@Component({
  components: {
    SendTransitTicketForm,
    FormCard
  }
})
export default class SendRequest extends Vue {
  private mounted() {
    window.scrollTo(0, 0);
  }
}
